import { combineReducers } from 'redux'

import wizard from './wizard'

export default combineReducers({
  wizard,
})
